<nav class="layout-breadcrumb" aria-label="Page">
  <!-- Desktop: the page's name, with one link up to the page it sits under. The menu shows the section. -->
  <div class="page-header">
    @if (parent() || kind()) {
      <p class="page-header-eyebrow">
        <!-- A back link, so it reads as one: the chevron points the way out, to the list this page sits under. -->
        @if (parent(); as up) {
          <a class="page-header-back" (click)="onBreadcrumbsClick(up)" [routerLink]="[up.url]" queryParamsHandling="merge"
            ><i class="pi pi-angle-left" aria-hidden="true"></i>{{ up.label }}</a
          >
        }
        @if (parent() && kind()) {
          <span aria-hidden="true">·</span>
        }
        @if (kind()) {
          <span>{{ kind() }}</span>
        }
      </p>
    }
    <h1 class="page-header-title">{{ title() }}</h1>
  </div>

  <!-- Below the desktop breakpoint the menu is hidden, so the full trail is still the way back up. -->
  <ol class="breadcrumb-trail">
    <li>
      <a [routerLink]="['/']" queryParamsHandling="merge" aria-label="Home">
        <i class="pi pi-home"></i>
      </a>
    </li>
    <li class="layout-breadcrumb-chevron">/</li>
    @for (item of ancestors(); track item.url) {
      <li>
        <a class="hover:underline" (click)="onBreadcrumbsClick(item)" [routerLink]="[item.url]" [queryParamsHandling]="'merge'">{{ item.label }}</a>
      </li>
      <li class="layout-breadcrumb-chevron">/</li>
    }
    <li>{{ title() }}</li>
  </ol>

  <!-- Wizard progress bar (US-3438), lifted here from the quote-v2 body for any quote not yet booked
       on a carrier. Steps are clickable to jump; state drives the badge + tint. -->
  @if (wizardProgress(); as wiz) {
    <ol class="bc-wiz">
      @for (s of wiz.steps; track s.index; let last = $last) {
        <li class="bc-wiz-step" [class]="'is-' + s.state" [class.is-static]="!s.clickable" [pTooltip]="s.tooltip" tooltipStyleClass="bc-wiz-tooltip" tooltipPosition="bottom" (click)="s.clickable && wiz.select(s.index)">
          @if (s.badge) {
            <span class="bc-wiz-num">{{ s.badge }}</span>
          }
          <span class="bc-wiz-text">
            <span class="bc-wiz-data">{{ s.summary }}</span>
            <span class="bc-wiz-label">{{ s.label }}</span>
          </span>
        </li>
        @if (!last) {
          <li class="bc-wiz-arrow" [class]="'is-' + s.state" aria-hidden="true">&#10230;</li>
        }
      }
    </ol>
  }
</nav>
